import { ContainerType } from './ContainerType'
import ChangeObservers from './ChangeObserver/ChangeObservers'
import Container from './Container'

export default class OverlayContainer extends Container {
  constructor () {
    super(ContainerType.OVERLAY, false)
    this._observer = null
  }

  _updateStyle (slot) {
    const container = slot.container()

    const loc = slot.targetNode().getBoundingClientRect()

    container.style.position = 'fixed'
    container.style.width = loc.width + 'px'
    container.style.height = loc.height + 'px'
    container.style.left = loc.left + 'px'
    container.style.top = loc.top + 'px'
    container.class = 'smrtb-overlay-container'

    const node = slot.node()
    node.style.position = 'absolute'
    node.style.bottom = '0px'
    node.style.left = '50%'
    node.style.transform = 'translate(-50%, 0%)'
  }

  maxSlotDims (slots) {
    const dims = [0, 0]

    for (const slot of slots) {
      const d = slot.targetNode().getBoundingClientRect()
      if (d.width > dims[0]) {
        dims[0] = d.width
      }
      if (d.height > dims[1]) {
        dims[1] = d.height
      }
    }

    return dims
  }

  style (bid, slot, media) {
    this._observer = new ChangeObservers(slot.node(), () => this._updateStyle(slot))
    slot.onDestroy(() => {
      this._observer.stop()
      // document.body.removeChild(slot.container())
    })

    this._updateStyle(slot)
  }
}
